// extracted by mini-css-extract-plugin
export var hideEditor = "_f2-2";
export var infoIcon = "_f2-3";
export var label = "_f2-1";
export var labelContainer = "_f2-0";
export var readonlyText = "_f2-4";